import React, { useState, useEffect } from 'react';
import Icon from '../icon'
import Spin from '../spin'
import Skeleton from '../skeleton'
import LocaleReceiver from 'antd/es/locale-provider/LocaleReceiver';
import defaultLocale from '../locale/default';
import "@whalecloud/fdx-theme-fdx/horizontal-select.less";

interface Option {
  label: string;
  value: string;
  disabled?: boolean;
}
interface HSLocale {
  more: string;
}
const HorizontalSelect = ({
  data,
  defaultValue,
  value,
  layout = 'inline',
  mode = 'single',
  disabled = false,
  collapsed = false,
  ctlBtnHidden = false,
  loading = false,
  onChange,
}: {
  data?: Array<Option>;
  defaultValue?: string | Array<string>;
  value?: string | Array<string>;
  layout?: 'horizontal' | 'inline';
  mode?: 'single' | 'multiple';
  disabled?: boolean;
  collapsed?: boolean;
  ctlBtnHidden?: boolean;
  loading?: boolean;
  onChange?: (values: Option | Array<Option>) => void;
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [activeItem, setActiveItem] = useState(-1)
  const [selectedItem, setSelectedItem] = useState([])
  const handleListClick = (index) => {
    if (disabled) return;
    if (mode === 'single') {
      if (!data[index].disabled) {
        setActiveItem(index)
        onChange(data[index])
      }
    } else if (mode === 'multiple') {
      if (data[index].disabled) return;
      if (selectedItem.includes(data[index])) {
        let tempArr = [...selectedItem]
        tempArr.splice(selectedItem.indexOf(data[index]), 1)
        setSelectedItem(tempArr)
      } else {
        setSelectedItem([...selectedItem, data[index]])
      }
    }

  }
  const addActiveClass = (index) => {
    if (mode === 'multiple') {
      if (selectedItem.indexOf(data[index]) > -1) {
        return true;
      }
    } else {
      if (index === activeItem) {
        return true;
      }
    }
    return false;
  }
  const setValue = (value) => {

    if (mode !== 'multiple' && Array.isArray(value)) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].value === value[0]) {
          setActiveItem(i)
        }
      }
    } else {
      let temp;
      if (!Array.isArray(value)) {
        temp = [value]
      } else {
        temp = value
      }

      let ArrIndex = []
      for (let i = 0; i < temp.length; i++) {
        for (let j = 0; j < data.length; j++) {
          if (temp[i] === data[j].value) {
            ArrIndex.push(j)
          }
        }
      }
      if (mode === 'single') {
        setActiveItem(ArrIndex[0])
      } else if (mode === 'multiple') {
        let temp = []
        for (let i = 0; i < ArrIndex.length; i++) {
          temp.push(data[ArrIndex[i]])
        }
        setSelectedItem(temp)
      }
    }
  }
  useEffect(() => {
    collapsed ? setIsCollapsed(true) : ''
    if (value) {
      setValue(value)
    } else if (defaultValue) {
      setValue(defaultValue)
    }
  }, [value]);
  useEffect(() => {
    /* Use this useEffect to perform actions when name get updated. */
    onChange ? onChange(selectedItem) : ''
  }, [selectedItem]);
  return (
    <LocaleReceiver componentName="HorizontalSelect" defaultLocale={defaultLocale.HorizontalSelect}>
      {(locale: HSLocale) => {
        return (
          <Spin spinning={loading}>
            <Skeleton loading={loading} active title={false} >
              <div className="screenDiv">
                <div className={`screenWrap ${disabled ? 'disableWrap' : ''}`}>
                  <ul className={`listWrap ${!isCollapsed ? "showWrap" : ''} ${layout === 'horizontal' ? "horizontalWrap" : ''}`}>
                    {data.map((item, index) => (
                      <li className={`listItem ${item.disabled ? "disableItem" : ''} ${addActiveClass(index) ? "activeItem" : ''} `}
                        key={index}
                        onClick={() => { handleListClick(index) }}
                      >
                        {item.label}
                      </li>
                    ))}
                    {
                      layout === 'horizontal' || ctlBtnHidden ? '' : (<span className="moreBtn" onClick={() => { !disabled && setIsCollapsed(!isCollapsed) }}>{locale.more}<span style={{ width: 16 }}><Icon type={isCollapsed ? "down" : "up"} /></span></span>)
                    }
                  </ul>
                </div>
              </div>
            </Skeleton>
          </Spin>
        )
      }}
    </LocaleReceiver>

  )
};


export default HorizontalSelect;



// WEBPACK FOOTER //
// ./src/components/horizontal-select/index.tsx